export default "__VITE_ASSET__iN5v9_lS__"